/**
 * Homepage — scroll-reveal animations
 * Uses IntersectionObserver to add .hp-visible when elements enter the viewport.
 * Compatible with Shopify Theme Editor (re-inits on shopify:section:load).
 */
(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;

  function init() {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = parseInt(entry.target.getAttribute('data-hp-delay'), 10) || 0;
            if (delay) {
              setTimeout(function () { entry.target.classList.add('hp-visible'); }, delay);
            } else {
              entry.target.classList.add('hp-visible');
            }
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.hp-animate:not(.hp-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Run on page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when Shopify Theme Editor loads a section */
  document.addEventListener('shopify:section:load', init);
})();

